import { AdminService } from 'src/app/_Core/_Services/admin.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { CommonService } from 'src/app/_Core/_Services/common.service';
import { ApiService } from 'src/app/_Core/_Services/api.service';
import { APIs } from 'src/app/_Core/_Constants/api.constant';
import { OnExecuteData, ReCaptchaV3Service } from 'ng-recaptcha';
import { timer, Subscription } from 'rxjs';
import { TimerService } from 'src/app/_Core/_Services/timer.service';
// import { timer, Subscription } from 'rxjs';
import { Pipe, PipeTransform } from '@angular/core';
import { take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  public barLabel: string = 'Password strength:';
  unamePattern = '^w+([.-]?w+)+@w+([.:]?w+)+(.[a-zA-Z0-9]{2,10})+$';
  forgotPasswordForm = new FormGroup({
    mobileEmailId: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$'),
    ]),
  });
  loginPassForm = new FormGroup({
    mobileEmailId: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$'),
    ]),
    password: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(8)])
    ),
  });
  otpValForm = new FormGroup({
    otp: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(6)])
    ),
  });
  changePasswordForm = new FormGroup({
    newPwd: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(8)])
    ),
    confPwd: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(8)])
    ),
  });
  setPassForm = new FormGroup({
    newpassword: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(8)])
    ),
    newpasswordconfirm: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(8)])
    ),
  });
  emailId;
  password;
  showErrorLoginpass;
  showForgotPassword;
  showLogin: boolean = true;
  showEmailSent: boolean;
  femailId;
  show: boolean;
  showPassword: boolean;
  showConfirmPassword: boolean;
  showSetPassword: boolean;
  newpassword;
  newpasswordconfirm;
  showDeactivated: boolean;
  invalidEmail: boolean = false;
  passwordError: boolean = false;
  isvalidBridgePlusEmail: boolean = true;
  invalidPWD: boolean = false;
  invalidConfirmPWD: boolean = false;
  invalidPasswordMatch: boolean = false;
  isLoginAttemptsFailure = false;
  passwordMinLengthError: boolean = false;
  newPasswordMinLengthError: boolean = false;
  newConfirmPasswordMinLengthError: boolean = false;
  passOneErr: boolean = false;
  passTwoErr: boolean = false;
  enableForgotPwdLink: boolean = true;
  emailSentText: any;
  capitalLogin: boolean = false;
  showBridgePlus: boolean = false;
  showCapitalLand: boolean = false;
  bridgePlusLogin: boolean = true;  //change
  loginType: string = '';
  tokens: any;
  encryptEmail: any;
  private subscription: Subscription;
  storeRecaptchaToken: any;

  showOtp: boolean = false;
  enterOtp: any;
  invalidOtp: boolean = false;
  showErrorOtp: any;
  remainingTime: number;
  finalSubmissionArray: { otp: string | null | undefined; email: string; password: any }[] = [];
  showChangePwd: boolean = false;

  enterConfPwd: any;
  enterNewPwd: any;
  invalidConfPwd: boolean = false;
  invalidNewPwd: boolean = false;
  showErrorConfPwd: any;
  sowErrorNewPwd: any;
  public deactiveBtn: any = true;
  finalSubmissionPasswordArray: { changedPassword: string | null | undefined; email: string; password: any }[] = [];
  showOtpEveryLogin: boolean = false;
  allowedLogin: boolean = false;
  showConfirmPasswordReenter: boolean;
  emailChecking: any;

  constructor(
    private _commonService: CommonService,
    private router: Router,
    private adalService: MsAdalAngular6Service,
    private appStateSrv: AppStateProvider,
    private adminSrv: AdminService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private timerService: TimerService
  ) {

    // this.logout();
    let riderctType;
    const loginToken = JSON.parse(localStorage.getItem('Tokens') ?? '[]');
    if (loginToken.length > 0) {
      riderctType = 'overview';
      this.appStateSrv.setLoginStatus(true);
      this.router.navigate([riderctType]).then(() => {
        window.location.reload()
      });
    }

    localStorage.setItem(AppConstant.localStorage.IsCLLogin, '0');
    // localStorage.removeItem('token');
    this.appStateSrv.setLoginStatus(false);
    this.appStateSrv.setIsInitialScreen(!this.bridgePlusLogin);
    this.route.queryParams.subscribe((params) => {
      if (params.type && params.type == 'resetPwd') {
        this.goToSetPassword();
        sessionStorage.setItem('resetToken', params.token);
      } else {
        this.backtoLogin();
      }
    });
  }

  ngOnInit(): void {
    this.startTimer();
  }

  startTimer(): void {
    this.timerService.startTimer();
    this.timerService.getTimer().subscribe((remainingTime) => {
      this.remainingTime = remainingTime;
    });
  }

  isResendDisabled(): boolean {
    return this.timerService.isTimerActive() || this.remainingTime > 0;
  }

  ngOnDestroy() {
    // this.countDown = null;
  }

  select(type) {
    if (type == 'bridgePlus') {
      this.showBridgePlus = true;
      this.showCapitalLand = false;
    }
    if (type == 'capitalLand') {
      this.showBridgePlus = false;
      this.showCapitalLand = true;
    }
    this.loginType = type;
  }

  submit() {
    // if (this.loginType == '') return;
    // if (this.loginType == 'bridgePlus') this.bridgePlusLogin = true;
    // if (this.loginType == 'capitalLand') this.capitalLogin = true;
    // this.appStateSrv.setIsInitialScreen(!this.bridgePlusLogin);

    let selectedTypeToken;
    let riderctType;
    if (this.loginType == 'bridgePlus') {
      riderctType = 'overview';
      selectedTypeToken = this.tokens.filter(res => {
        if (res.userType === 'Bridge+') {
          return res;
        }
      });
    } else if (this.loginType == 'capitalLand') {
      riderctType = 'overview';
      selectedTypeToken = this.tokens.filter(res => {
        if (res.userType === 'Parkite') {
          return res;
        }
      });
    }

    this.appStateSrv.setLoginStatus(true);
    this._commonService.setToken(selectedTypeToken[0]);
    this.router.navigate([riderctType]).then(() => {
      window.location.reload()
    });
  }

  backtoLogin() {
    this.showDeactivated = false;
    this.showForgotPassword = false;
    this.showSetPassword = false;
    this.showLogin = true;
    this.showEmailSent = false;
    this.enableForgotPwdLink = true;
    // localStorage.clear();
  }
  // CLALogin() {
  //   if (this.emailId != "") {
  //     if (String(this.emailId).toLocaleLowerCase().indexOf(AppConstant.localStorage.Domain) > -1) {
  //       localStorage.setItem(AppConstant.localStorage.IsCLLogin, "1");
  //       this.adalService.login();
  //     }
  //   }
  // }

  validatedPwdRegex(field: number) {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-#^_+=])[A-Za-z\d@$!%*?&\-#^_+=]{8,}$/;
    switch (field) {
      case 1:
        if (!regex.test(this.newpassword)) this.passOneErr = true;
        else this.passOneErr = false;
        break;
      case 2:
        if (!regex.test(this.newpasswordconfirm)) this.passTwoErr = true;
        else this.passTwoErr = false;
        break;
    }
  }

  validateEmail() {
    if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,15}$/.test(this.emailId)) {
      this.invalidEmail = true;
    } else {
      this.invalidEmail = false;
    }
  }

  checkRecaptchaToken() {
    this.storeRecaptchaToken = '';
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token: string) => {

        const authSubmissionArray = {
          email: btoa(this.emailId.toLowerCase()),
          password: this.password,
        }
        this._commonService
          .checkUserAuthentication(authSubmissionArray)
          .subscribe((authresp) => {
            if (authresp.isValid === false) {
              return false;
            } else {
              this.storeRecaptchaToken = token;

              let pwdexpurl: string = APIs.checkUserPasswordExpiry;
              const paramObjpwd = {
                email: btoa(this.emailId.toLowerCase()),
                password: this.password,
              }

              this._commonService
                .checkUserPasswordExp(paramObjpwd).subscribe(
                  (responsedata: any) => {
                    if (responsedata?.data?.isFirstTimeLogin === true) {
                      this.showChangePwd = true;
                      this.showLogin = false;
                      this.showOtp = false;
                      this.showOtpEveryLogin = false;
                      return;
                    } else {
                      if (responsedata.isValid === true) {

                        let otpsendurl: string = APIs.taOtpGeneration;
                        const paramObjotp = {
                          email: btoa(this.emailId.toLowerCase()),
                          password: this.password,
                        }

                        this._commonService
                          .taLoginOtpForPortal(paramObjotp).subscribe(
                            (responsedataotp: any) => {
                              if (responsedataotp.isValid == true) {
                                this.showOtpEveryLogin = true;
                                this.showLogin = false;
                                this.showOtp = false;
                                this.showChangePwd = false;
                                this.allowedLogin = false;
                                return false;
                              } else {
                                this.showOtpEveryLogin = false;
                                this.showLogin = true;
                                this.showOtp = false;
                                this.showChangePwd = false;
                                this.allowedLogin = false;
                                return false;
                              }
                            });
                      } else {

                        let otpsendurl: string = APIs.generateOtp;
                        const paramObjotpExp = {
                          email: btoa(this.emailId.toLowerCase()),
                          password: this.password,
                        }

                        this._commonService
                          .generateOTPasswordExp(paramObjotpExp).subscribe(
                            (responsedataotp: any) => {
                              if (responsedataotp.isValid == true) {
                                this.showLogin = false;
                                this.showOtp = true;
                                this.showOtpEveryLogin = false;
                                this.showChangePwd = false;
                              } else {
                                this.showLogin = true;
                                this.showOtp = false;
                                this.showOtpEveryLogin = false;
                                this.showChangePwd = false;
                              }
                            });
                      }
                    }
                  });
            }
          });
      });
  }

  submitLogin() {


  }

  confirm() {
    this.invalidPWD = false;
    this.invalidConfirmPWD = false;
    this.invalidPasswordMatch = false;
    this.newPasswordMinLengthError = false;
    this.newConfirmPasswordMinLengthError = false;

    if (this.newpassword == '' || this.newpassword == undefined) {
      this.invalidPWD = true;
      return;
    } else {
      this.invalidPWD = false;
    }

    if (this.newpasswordconfirm == '' || this.newpasswordconfirm == undefined) {
      this.invalidConfirmPWD = true;
      return;
    } else {
      this.invalidConfirmPWD = false;
    }

    if (this.newpassword === this.newpasswordconfirm) {
      this.invalidPasswordMatch = false;
    } else {
      this.invalidPasswordMatch = true;
      return;
    }

    if (this.newpassword.length < 8) {
      this.newPasswordMinLengthError = true;
      return;
    } else {
      this.newPasswordMinLengthError = false;
    }

    if (this.newpasswordconfirm.length < 8) {
      this.newConfirmPasswordMinLengthError = true;
      return;
    } else {
      this.newConfirmPasswordMinLengthError = false;
    }

    this.showDeactivated = false;
    this.showForgotPassword = false;
    this.showSetPassword = true;
    this.showLogin = false;
    this.showEmailSent = false;
    this.route.queryParams.subscribe(res => {
      this.encryptEmail = res?.email
    })

    this.adminSrv
      .resetPwd(
        this.newpassword,
        sessionStorage.getItem('resetToken'), this.encryptEmail
      )
      .subscribe((response) => {
        // let result: boolean = response.isValid;
        if (response.isValid == true) {
          sessionStorage.removeItem('resetToken');
          this.backtoLogin();
        } else {
          this.goToSetPassword();
        }
      });
  }

  submitResetInstruction() {

    this.storeRecaptchaToken = '';
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token: string) => {
        this.storeRecaptchaToken = token;

        this.isvalidBridgePlusEmail = true;
        this.invalidEmail = false;
        if (
          !/^[a-zA-Z0-9_]+([.\-][a-zA-Z0-9_]+)*@[a-zA-Z0-9]+([.\-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,3}$/.test(
            this.emailId
          )
        ) {
          this.invalidEmail = true;
          return;
        } else {
          this.invalidEmail = false;
        }

        const paramObj = {
          emailId: btoa(this.emailId.toLowerCase()),
          captchaToken: token
        };

        let url: string = APIs.isTenantAdminExists;
        this.apiService.post(url, paramObj).subscribe((response: any) => {
          this.isvalidBridgePlusEmail = response.isValid;

          if (this.isvalidBridgePlusEmail) {
            this.adminSrv
              .forgotPasswordPortal(btoa(this.emailId.toLowerCase()))
              .subscribe((response) => {
                let resetPwd: boolean = response.isValid;
                // if (resetPwd) {
                this.showForgotPassword = false;
                this.showSetPassword = false;
                this.showLogin = false;
                this.showDeactivated = false;
                this.showEmailSent = true;
                this.enableForgotPwdLink = false;
                this.emailSentText = response.successMsg || response.errorMsg;
                this.emailChecking = response.isValid;
                // }
              });
          }
        });
      });
  }

  forgotPassword() {
    // this.showErrorLoginpass = false;
    // this.showForgotPassword = true;
    // this.showSetPassword = false;
    // this.showLogin = false;
    // this.showDeactivated = false;
    this.submitResetInstruction();
  }

  tryAgain() {
    this.showForgotPassword = true;
    this.showSetPassword = false;
    this.showLogin = false;
    this.showEmailSent = false;
    this.showDeactivated = false;
  }

  togglePassword() {
    this.show = !this.show;
  }

  toggleResetPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  toggleConfirmPasswordReEnter() {
    this.showConfirmPasswordReenter = !this.showConfirmPasswordReenter;
  }

  goToSetPassword() {
    this.showSetPassword = true;
    this.showForgotPassword = false;
    this.showLogin = false;
    this.showEmailSent = false;
    this.showDeactivated = false;
  }

  resendOtp() {
    this.timerService.stopTimer();
    this.startTimer();
    let otpsendurl: string = APIs.generateOtp;

    const paramObjotp = {
      email: btoa(this.emailId.toLowerCase()),
      password: this.password
    }

    this._commonService
      .generateOTPasswordExp(paramObjotp).subscribe(
        (responsedataotp: any) => {
          if (responsedataotp.isValid == true) {

          }
        });
  }

  resendOtpForTaLogin() {
    this.timerService.stopTimer();
    this.startTimer();
    let otpsendurl: string = APIs.taOtpGeneration;

    const paramObjotp = {
      email: btoa(this.emailId.toLowerCase()),
      password: this.password
    }

    this._commonService
      .taLoginOtpForPortal(paramObjotp).subscribe(
        (responsedataotp: any) => {
          if (responsedataotp.isValid == true) {

          }
        });
  }


  onSubmitOtp() {

    this.invalidOtp = false;

    if (this.otpValForm.valid) {

      this.finalSubmissionArray = [];
      this.finalSubmissionArray.push({
        "otp": this.otpValForm.value.otp,
        "email": btoa(this.emailId.toLowerCase()),
        "password": this.password,
      });

      this._commonService
        .verifyLoginOtp(this.finalSubmissionArray[0])
        .subscribe((resverifyotp) => {
          if (resverifyotp.isValid == true) {
            this.showOtp = false;
            this.showLogin = false;
            this.showChangePwd = true;
            this.showOtpEveryLogin = false;
          } else {
            this.showLogin = false;
            this.showOtp = true;
            this.showChangePwd = false;
            this.showOtpEveryLogin = false;
          }
        });
    } else {
      this.otpValForm.markAllAsTouched();
    }
  }

  onSubmitOtpForTaLogin() {

    this.invalidOtp = false;

    if (this.otpValForm.valid) {

      this.finalSubmissionArray = [];
      this.finalSubmissionArray.push({
        "otp": this.otpValForm.value.otp,
        "email": btoa(this.emailId.toLowerCase()),
        "password": this.password,
      });

      this._commonService
        .verifyLoginOtp(this.finalSubmissionArray[0])
        .subscribe((resverifyotp) => {
          if (resverifyotp.isValid == true) {
            this.showOtp = false;
            this.showLogin = false;
            this.showChangePwd = false;
            this.showOtpEveryLogin = true;
            this.allowedLogin = true;

            this.isvalidBridgePlusEmail = true;
            this.invalidEmail = false;
            this.passwordError = false;
            this.passwordMinLengthError = false;

            if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,15}$/.test(this.emailId)) {
              this.invalidEmail = true;
              return;
            } else {
              this.invalidEmail = false;
            }
            if (this.password == '' || this.password == undefined) {
              this.passwordError = true;
              return;
            } else {
              this.passwordError = false;
            }

            if (this.password.length < 8) {
              this.passwordMinLengthError = true;
              return;
            } else {
              this.passwordMinLengthError = false;
            }

            if (this.invalidEmail || this.passwordError) return;
            this.invalidEmail = false;
            this.passwordError = false;
            if (this.emailId == '') {
              this.invalidEmail = true;
              return;
            }
            if (this.password == '') {
              this.passwordError = true;
              return;
            }


            this.storeRecaptchaToken = '';
            this.recaptchaV3Service.execute('importantAction')
              .subscribe((token: string) => {

                this.storeRecaptchaToken = token;

                if (this.emailId != '' && this.password != '') {
                  //Validate whether given email id is valid bridge+ user email id
                  const paramObj = {
                    emailId: btoa(this.emailId.toLowerCase()),
                    captchaToken: this.storeRecaptchaToken, // token
                  };
                  let url: string = APIs.isTenantAdminExists;
                  this.apiService.post(url, paramObj).subscribe({
                    next: (response: any) => {
                      if (response.data == null) {
                        this.isvalidBridgePlusEmail = false;
                      } else if (response.isValid === false) {
                        this.isvalidBridgePlusEmail = false;
                        this.showErrorLoginpass = false;
                        this.showForgotPassword = false;
                        this.showSetPassword = false;
                        this.showLogin = false;
                        this.showDeactivated = true;
                        return;
                      } else {
                        this.isvalidBridgePlusEmail = true;

                        if (this.isvalidBridgePlusEmail) {
                          this._commonService
                            .getApiauthorizationToken(this.emailId.toLowerCase(), this.password)
                            .subscribe((res) => {

                              if (!res.status) {
                                if (res.isUserLocked === 'True') {
                                  this.isLoginAttemptsFailure = true;
                                } else {
                                  setTimeout(() => { window.location.reload(); }, 3000),
                                    this.isLoginAttemptsFailure = false;
                                  this.showErrorLoginpass = false;
                                }
                                return;
                              }
                              this.tokens = JSON.parse(localStorage.getItem('Tokens') ?? '[]');
                              if (this.tokens.length > 1) {
                                this.bridgePlusLogin = false;
                              } else {
                                this.allowedLogin = false;
                                this._commonService.setToken(this.tokens[0]);
                                this.appStateSrv.setLoginStatus(true);
                                this.router.navigate(['overview']).then(() => {
                                  // window.location.reload()
                                });
                              }
                            });
                        }

                        if (response.data.isActive == false) {
                          this.showErrorLoginpass = false;
                          this.showForgotPassword = false;
                          this.showSetPassword = false;
                          this.showLogin = false;
                          this.showDeactivated = true;
                          return;
                        }
                      }


                    },
                    error: (err) => {}
                  });
                } else {
                  // this.showErrorLoginpass = true;
                  if (
                    this.password == '' ||
                    this.password == undefined ||
                    this.password == null
                  )
                    this.passwordError = true;
                }
              });
          } else {
            this.allowedLogin = false;
            this.showLogin = false;
            this.showOtp = false;
            this.showChangePwd = false;
            this.showOtpEveryLogin = true;
          }
        });
    } else {
      this.otpValForm.markAllAsTouched();
    }
  }

  getFormattedTime(timeInSeconds: number): string {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    const formattedMinutes = this.padWithZero(minutes);
    const formattedSeconds = this.padWithZero(seconds);

    return `${formattedMinutes}:${formattedSeconds}`;
  }

  private padWithZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  onSubmitChangePassword() {
    this.invalidConfPwd = false;
    this.invalidNewPwd = false;

    if (this.changePasswordForm.valid) {

      this.finalSubmissionPasswordArray = [];
      this.finalSubmissionPasswordArray.push({
        "changedPassword": this.changePasswordForm.value.newPwd,
        "email": btoa(this.emailId.toLowerCase()),
        "password": this.password,
      });

      this._commonService
        .changeLoginPassword(this.finalSubmissionPasswordArray[0])
        .subscribe((resverifypass) => {
          if (resverifypass.isValid == true) {
            this.showOtp = false;
            this.showChangePwd = false;
            this.showLogin = true;
            this.showOtpEveryLogin = false;
          } else {
            this.showLogin = false;
            this.showOtp = false;
            this.showChangePwd = true;
            this.showOtpEveryLogin = false;
          }
        });
    } else {
      this.changePasswordForm.markAllAsTouched();
    }
  }

  checkMatchPasswords(event: string) {
    if (this.enterNewPwd !== event) {
      this.deactiveBtn = false;
    } else {
      this.deactiveBtn = true;
    }
  }

  logout() {
    this._commonService.logoutToken().subscribe((res) => {
      if (res) {
        localStorage.clear();
        if (this.adalService.isAuthenticated == true) {
          this.adalService.logout();
        }
        this.router.navigateByUrl('').then(() => {
          window.location.reload();
        });
      }
    });
  }

}
